
function OptionCard(props) {
    return (
        <div id="option-card" className={`${props.disabled ? "disabled" : ""} ${props.selected ? "g-purp" : ""}`} onClick={props.onClick}>
            <h5>{props.text}</h5>
        </div>
    );
}

export default OptionCard;